'use client';
import React, { Fragment, useEffect, useRef } from 'react';
import { useState } from 'react';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import Input from '@/components/ui/forms/Input';
import Textarea from '@/components/ui/forms/Textarea';
import Button from '@/components/ui/forms/Button';
import ButtonLoading from '@/components/ui/forms/ButtonLoading';
import { FaCircleChevronRight } from 'react-icons/fa6';
import Errors from '@/components/ui/alerts/Errors';
import Success from '@/components/ui/alerts/Success';
import { ApiRoutes, Routes } from '@/settings/routes';
import Error from '@/components/ui/alerts/Error';
import axios from '@/lib/axios';
import Label from '@/components/ui/forms/Label';
import { useRouter } from 'next/navigation';

export default function FormOrder({ type, dataPost }) {
    const router = useRouter();
    const [selected, setSelected] = useState();
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState('');
    const [processing, setProcessing] = useState(false);
    const [reservation, setReservation] = useState({
        name: '',
        email: '',
        phone: null,
        travels: null,
        message: '',
    });

    const [isFormVisible, setIsFormVisible] = useState(true);
    const formRef = useRef(null);
    const buttonOrderRef = useRef(null);

    let footer = <p>Select your travel date</p>;
    if (selected) {
        footer = <p>You picked {format(selected, 'PP')}.</p>;
    }

    const handelInput = (e) => {
        e.persist();

        let { name, value } = e.target;
        setReservation({ ...reservation, [name]: value });
    };

    const submitReservation = async (e) => {
        e.preventDefault();

        setError('');
        setErrors({});

        // Updated URL generation logic for different post types
        let data = {
            date: selected !== undefined ? format(selected, 'yyyy-MM-dd') : null,
            name: reservation.name,
            email: reservation.email,
            travels: reservation.travels,
            phone: reservation.phone,
            message: reservation.message,
            title: dataPost?.title,
            type: type,
            // Dynamic URL generation based on post type
            url: (() => {
                switch (type) {
                    case 'activities':
                        return `${Routes.FRONT_activity}${dataPost?.slug}`;
                    case 'tours':
                        return `${Routes.FRONT_tour}${dataPost?.slug}`;
                    case 'city_breaks':
                        return `${Routes.FRONT_city_break}${dataPost?.slug}`;
                    case 'events':
                        return `${Routes.FRONT_event}${dataPost?.slug}`;
                    default:
                        return `/${type}/${dataPost?.slug}`;
                }
            })(),
            id: dataPost?.id,
        };

        setProcessing(true);
        try {
            const res = await axios.post(ApiRoutes.API_submit_order, data);

            if (res.data.status === 200) {
                // Set success message
                setSuccess(res.data.message);

                router.push(`${Routes.FRONT_thank_you}`);

                // Check if there was an email sending issue
                if (res.data.email_error) {
                    console.warn('Email notification failed, but reservation was successful');
                }

                // Reset form
                setReservation({});
                setSelected(undefined);
            } else if (res.data.status === 401) {
                // Handle validation errors
                setErrors(res.data.errors || {});
            } else if (res.data.status === 500) {
                // Handle server errors
                setError(res.data.message || 'Server error occurred. Please try again later.');
            } else {
                // Handle any other status codes
                setError('Whoops! Something went wrong, please try later');
            }
        } catch (error) {
            console.error('Reservation submission error:', error);

            setProcessing(false);

            // Check for specific error responses
            if (error.response) {
                const { status, data } = error.response;

                if (status === 422) {
                    // Validation errors
                    setError('Please check your input and try again.');
                    if (data.errors) {
                        setErrors(data.errors);
                    }
                } else if (status === 500) {
                    // Server error
                    setError('Our server is experiencing issues. Please try again later.');
                } else if (status === 401) {
                    // Validation errors from our custom response
                    if (data.errors) {
                        setErrors(data.errors || {});
                    } else {
                        setError(data.message || 'Please check your input and try again.');
                    }
                } else {
                    // Any other error
                    setError('An unexpected error occurred. Please try again later.');
                }
            } else if (error.request) {
                // The request was made but no response was received
                setError('Unable to connect to the server. Please check your internet connection and try again.');
            } else {
                // Something happened in setting up the request
                setError('An error occurred while submitting your reservation. Please try again.');
            }
        } finally {
            setProcessing(false);
        }
    };

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        };

        const observer = new IntersectionObserver(([entry]) => {
            setIsFormVisible(entry.isIntersecting);
        }, options);

        if (formRef.current) {
            observer.observe(formRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    const handleButtonClick = () => {
        if (formRef.current) {
            const targetPosition = formRef.current.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = targetPosition - 200; // Adjust 10 pixels above the element
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <Fragment>
            <div id="form_order" className="relative" ref={formRef}>
                <Errors errors={errors} />
                <Error message={error} />
                <form onSubmit={submitReservation} className="flex flex-col gap-3 mb-3">
                    {/* {type !== 'events' && (
                        <div>
                            <Label htmlFor={'date'}>travel date</Label>
                            <div className="w-full hs-dropdown relative sm:inline-flex z-20 [--auto-close:inside]">
                                <button
                                    id="hs-dropdown-auto-close-inside"
                                    type="button"
                                    className={`hs-dropdown-toggle rounded-lg w-full py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold border border-gray-200 bg-white ${
                                        selected ? 'default-color-title' : 'text-gray-500/90'
                                    } hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 focus:!border-main-color focus:!ring-0`}
                                >
                                    {footer}
                                </button>
                                <div
                                    className="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden mt-2 bg-white shadow-md rounded-lg p-2 dark:bg-gray-800 dark:border dark:border-gray-700"
                                    aria-labelledby="hs-dropdown-auto-close-inside"
                                >
                                    <DayPicker mode="single" selected={selected} onSelect={setSelected} footer={footer} />
                                </div>
                            </div>
                        </div>
                    )} */}
                    <div>
                        <Label htmlFor={'name'}>Your name</Label>
                        <Input
                            onChange={handelInput}
                            defaultValue={reservation?.name}
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Your name*"
                            className="font-semibold text-base  focus:!border-main-color focus:!ring-0"
                            required
                        />
                    </div>
                    <div>
                        <Label htmlFor={'email'}>Your email</Label>
                        <Input
                            onChange={handelInput}
                            defaultValue={reservation?.email}
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Your email*"
                            className="font-semibold text-base  focus:!border-main-color focus:!ring-0"
                            required
                        />
                    </div>
                    {type === 'events' && (
                        <div>
                            <Label htmlFor={'phone'}>Your phone</Label>
                            <Input
                                onChange={handelInput}
                                defaultValue={reservation?.phone}
                                type="text"
                                id="phone"
                                name="phone"
                                placeholder="Your phone"
                                className="font-semibold text-base  focus:!border-main-color focus:!ring-0"
                            />
                        </div>
                    )}
                    <div>
                        <Label htmlFor={'travels'}>Travelers</Label>
                        <Input
                            onChange={handelInput}
                            defaultValue={reservation?.travels}
                            type="number"
                            name="travels"
                            id="travels"
                            min={0}
                            placeholder="Travelers*"
                            className="font-semibold text-base  focus:!border-main-color focus:!ring-0"
                            required
                        />
                    </div>
                    <div>
                        <Label htmlFor={'message'}>Your message</Label>
                        <Textarea
                            onChange={handelInput}
                            defaultValue={reservation?.message}
                            rows="4"
                            name="message"
                            id="message"
                            placeholder="Your message*"
                            className="font-semibold text-base  focus:!border-main-color focus:!ring-0"
                            required
                        />
                    </div>
                    <div className="w-full">
                        {processing === false ? (
                            <Button type="submit" className={`flex gap-2 items-center w-full text-sm font-semibold text-white transition-colors btn ounded-md group hover-bg`}>
                                <span>Send</span>
                                <FaCircleChevronRight className="size-4" />
                            </Button>
                        ) : (
                            <ButtonLoading className="flex gap-2 items-center w-full text-sm font-semibold text-white opacity-75 transition-colors btn ounded-md group hover-bg" />
                        )}
                    </div>
                </form>
                <Success message={success} />
            </div>
            {!isFormVisible && (
                <div id="button_order" onClick={handleButtonClick} className="fixed left-0 bottom-14 z-50 p-4 w-full xl:hidden">
                    <Button type="submit" className={`flex gap-2 items-center w-full h-12 text-sm font-semibold text-white transition-colors btn ounded-md group hover-bg`}>
                        <span>Get Free Quote</span>
                        <FaCircleChevronRight className="size-4" />
                    </Button>
                </div>
            )}
        </Fragment>
    );
}
